(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    if ('IntersectionObserver' in window && !reduced.matches && !window.Shopify?.designMode) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
      }, { threshold: 0.08 });
      root.querySelectorAll('[data-vs-reveal]:not(.vs-reveal-ready)').forEach(el => {
        if (el.getBoundingClientRect().top > window.innerHeight - 30) { el.classList.add('vs-reveal-ready'); observer.observe(el); }
      });
    }
    root.querySelectorAll('[data-vs-sort]').forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); url.searchParams.delete('page'); window.location.assign(url); });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.vs-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.vs-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
